export function currencyToNumber(value: string): number {
	if (!value) return 0;
	return parseFloat(value.replace(/\./g, "").replace(",", "."));
};